module.exports = __webpack_public_path__ + "static/media/fal_fal_cra_boa.0bf28a44.png";